/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action/raid': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _fill="#1D1D1B"><path pid="0" d="M16 32C7.178 32 0 24.822 0 16S7.178 0 16 0s16 7.178 16 16-7.178 16-16 16zm0-30C8.28 2 2 8.28 2 16s6.28 14 14 14 14-6.28 14-14S23.72 2 16 2z"/><path pid="1" d="M16 4C9.371 4 4 9.372 4 16c0 6.629 5.371 12 12 12s12-5.371 12-12c0-6.628-5.371-12-12-12zm.646 2.646a.5.5 0 01.707 0l2 2a.5.5 0 01-.707.708l-2-2a.502.502 0 010-.708zm-1.292 17.708a.502.502 0 01-.708 0l-2-2a.5.5 0 01.707-.707l2 2a.5.5 0 01.001.707zm7.5-1.5c-.193.193-.46.275-.767.275-1.085 0-2.686-1.021-3.44-1.775l-9.5-9.5.707-.707 9.5 9.5c.978.978 2.519 1.591 2.824 1.477.067-.256-.554-1.792-1.531-2.77l-9.5-9.5.707-.707 9.5 9.5c.968.968 2.375 3.331 1.5 4.207z"/></g>'
  }
})
